var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet, KeyValue, Layout, List, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { FieldRow } from "../../components/FieldRow";
import { AccordionSection } from "../../components/AccordionSection";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
var UserDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var user = _a.user;
    var formatMessage = useIntl().formatMessage;
    var _l = useState({
        general: true,
        libraries: true,
    }), accordionStatus = _l[0], setAccordionStatus = _l[1];
    var _m = useState(true), expandAll = _m[0], setExpandAll = _m[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
                libraries: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
                libraries: true,
            });
        }
        setExpandAll(!expandAll);
    };
    var isUserAdmin = (_c = (_b = user.libraries) === null || _b === void 0 ? void 0 : _b.some(function (lib) { return lib.isAdmin; })) !== null && _c !== void 0 ? _c : false;
    var renderLibraryItem = function (lib) {
        var _a, _b, _c;
        return (React.createElement("div", { key: lib.id, style: {
                marginBottom: "1rem",
                paddingBottom: "1rem",
                borderBottom: "1px solid #e0e0e0",
            } },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("strong", null, (_a = lib.library) === null || _a === void 0 ? void 0 : _a.name))),
            React.createElement(Row, { style: { marginTop: "0.5rem" } },
                React.createElement(Col, { xs: 6 },
                    React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.users.field.roleInLibrary", value: lib.isAdmin
                            ? formatMessage({ id: "ui-br-legaldeposits.userRole.admin" })
                            : formatMessage({
                                id: "ui-br-legaldeposits.userRole.librarian",
                            }) })),
                React.createElement(Col, { xs: 6 },
                    React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.users.field.permissionsLabel", value: [
                            ((_b = lib.permissions) === null || _b === void 0 ? void 0 : _b.monographs) &&
                                formatMessage({
                                    id: "ui-br-legaldeposits.users.permission.monographs",
                                }),
                            ((_c = lib.permissions) === null || _c === void 0 ? void 0 : _c.periodicals) &&
                                formatMessage({
                                    id: "ui-br-legaldeposits.users.permission.periodicals",
                                }),
                        ]
                            .filter(Boolean)
                            .join(" + ") || "-" })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.detail.pane.title" })),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-legaldeposits.users.accordion.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.users.field.name", value: "".concat(user.firstName || "", " ").concat(user.lastName || "").trim() || "-" })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.users.field.email", value: (_d = user.email) !== null && _d !== void 0 ? _d : "-" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.users.field.role", value: isUserAdmin
                                ? formatMessage({
                                    id: "ui-br-legaldeposits.userRole.admin",
                                })
                                : formatMessage({
                                    id: "ui-br-legaldeposits.userRole.librarian",
                                }) })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.users.field.librariesCount", value: ((_f = (_e = user.libraries) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0).toString() }))),
                React.createElement(Layout, { className: "marginTop1" },
                    React.createElement(KeyValue, { label: formatMessage({
                            id: "ui-br-legaldeposits.users.field.status",
                        }), value: formatMessage({
                            id: "ui-br-legaldeposits.userStatus.".concat(((_g = user.status) !== null && _g !== void 0 ? _g : "ACTIVE").toLowerCase()),
                        }) }))),
            React.createElement(AccordionSection, { id: "libraries-info", labelId: "ui-br-legaldeposits.users.accordion.libraries", open: accordionStatus.libraries, onToggle: function () { return toggleAccordion("libraries"); } }, ((_j = (_h = user.libraries) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : 0) === 0 ? (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.users.detail.noLibraries" }))) : (React.createElement(List, { items: (_k = user.libraries) !== null && _k !== void 0 ? _k : [], itemFormatter: renderLibraryItem, listStyle: "default" }))))));
};
export default UserDetail;
